// extracted by mini-css-extract-plugin
module.exports = {"externalId":"_2G0ih-qMF0uLhiy13Vx5Wl"};